"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SummatedComponent_1 = require("./SummatedComponent");
var SummatedComponentStyle_1 = require("../../components/SummatedComponentStyle");
var summatedStyle = SummatedComponentStyle_1.default(true);
var ExplanationComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null,
        React.createElement("strong", null,
            React.createElement("em", null, "The North Face Cup 2019")),
        " is a simple format that tracks the number of Tops/Zones that the climber achieves. It is created specifically for the series of competitions hosted by gyms in Asia, under the banner of TNF."),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null, "For this format used by The North Face Cup, climbers will have to reach and achieve stable control of the \"Top\" and 2 \"Zone\" holds within each problem. The organizers will track the submission of the scorecards, and the order of scoring is:"),
    React.createElement("ol", null,
        React.createElement("li", null, "Most Tops achieved"),
        React.createElement("li", null, "Most Zone-2s achieved"),
        React.createElement("li", null, "Most Zone-1s achieved"),
        React.createElement("li", null, "Earliest paper scorecard submission by climber")),
    React.createElement("p", null, "The aim is to get the most Tops/Zones in the least attempts!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Example")),
    React.createElement("span", null,
        "Climber's result: ",
        React.createElement("em", null,
            React.createElement(SummatedComponent_1.default, { summated: { top: 3, zone2: 2, zone1: 1, display: '' }, style: summatedStyle }))),
    React.createElement("p", null,
        "For the above result, the climber scored a total of 3 Tops ",
        React.createElement("em", null, "(T)"),
        ", 2 Zone2s ",
        React.createElement("em", null, "(Z\u00B2)"),
        ", and 1 Zone1s ",
        React.createElement("em", null, "(Z\u00B9)"),
        "."))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/NorthFaceCup2019/ExplanationComponent.js
// module id = 1030
// module chunks = 0